import { accidentList } from '@/api/serviceAPi'
import { FuzzySearch } from '@/api/purchaseAndSaleAPI'
import selectOption from '@/store/dict/selectOptionDict'

export default function (data) {
  const { dealWithData } = data
  const oLoading = {
    fuzzy: false,
  }

  // 搜索车牌号
  const getPlateNoData = async (query) => {
    if (query.length >= 4) {
      oLoading.fuzzy = true
      // eslint-disable-next-line no-shadow
      const { code, data } = await FuzzySearch({
        plateNo: query,
        state: 1,
      })
      oLoading.fuzzy = false
      if (code === 1) {
        this.$refs.baseListManagement.setItemData({ elConfigKey: 'list', key: 'carId', data })
      } else {
        this.$refs.baseListManagement.setItemData({ elConfigKey: 'list', key: 'carId', data: [] })
      }
    }
  }

  const dealWithSearch = (params) => {
    if (dealWithData)dealWithData(params)
    if (params.caseDate && params.caseDate.length) {
      const [start, end] = params.caseDate
      params.reportDateBegin = start
      params.reportDateEnd = end
    }
    return params
  }

  const configData = {
    formData: {
      list: [
        {
          el: 'input',
          itemConfig: {
            label: '事故ID',
            prop: 'id',
          },
          directives: [{ name: 'number', arg: 'integer', value: 18 }],
          elConfig: {
            clearable: true,
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '车牌号',
            prop: 'carId',
          },
          elConfig: {
            filterable: true,
            remote: true,
            'reserve-keyword': true,
            loading: oLoading.fuzzy,
            placeholder: '请输入',
            'remote-method': (e) => { getPlateNoData(e, 'carId') },
            options: {
              label: 'plateNo',
              value: 'id',
              list: [],
            },
          },
        },
        {
          el: 'date-picker',
          itemConfig: {
            label: '报案日',
            prop: 'caseDate',
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '事故责任',
            prop: 'accidentBlame',
          },
          elConfig: {
            clearable: true,
            options: {
              label: 'label',
              value: 'value',
              list: this.dictParseList(selectOption.accidentResponsibilityDict, true),
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '事故状态',
            prop: 'accidentStatus',
          },
          elConfig: {
            clearable: true,
            options: {
              label: 'label',
              value: 'value',
              list: this.dictParseList(selectOption.accidentStatusDict, true),
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '结算状态',
            prop: 'settlementStatus',
          },
          elConfig: {
            clearable: true,
            options: {
              label: 'label',
              value: 'value',
              list: this.dictParseList(selectOption.settlementForm, true),
            },
          },
        },
      ],
      dealWithSearch,
    },
    tableData: {
      columns: [
        {
          name: 'id',
          columnProps: {
            prop: 'id',
            label: '事故ID',
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            prop: 'plateNo',
            label: '车牌号',
            width: 100,
          },
          showColumnItem: !this.isCarDetail,

        },
        {
          name: 'brandName',
          columnProps: {
            prop: 'brandName',
            label: '品牌',
          },
          showColumnItem: !this.isCarDetail,
        },
        {
          name: 'seriesName',
          columnProps: {
            prop: 'seriesName',
            label: '车系',
          },
          showColumnItem: !this.isCarDetail,
        },
        {
          name: 'carModelName',
          columnProps: {
            prop: 'carModelName',
            label: '车型',
          },
          showColumnItem: !this.isCarDetail,
        },
        {
          name: 'customerName',
          columnProps: {
            prop: 'customerName',
            label: '客户信息',
          },
        },
        {
          name: 'reportDate',
          columnProps: {
            prop: 'reportDate',
            label: '报案日',
          },
        },
        {
          name: 'accidentBlame',
          columnProps: {
            prop: 'accidentBlame',
            label: '事故责任',
          },
          getText: ({ row }) => selectOption.accidentResponsibilityDict[row.accidentBlame],
        },
        {
          name: 'claimState',
          columnProps: {
            prop: 'claimState',
            label: '出险状态',
          },
          getText: ({ row }) => selectOption.outInsuranceStatusDict[row.claimState],
        },
        {
          name: 'accidentStatus',
          columnProps: {
            prop: 'accidentStatus',
            label: '事故状态',
            width: 120,
          },
          getText: ({ row }) => selectOption.accidentStatusDict[row.accidentStatus],
        },
        {
          name: 'settlementStatus',
          columnProps: {
            prop: 'settlementStatus',
            label: '结算状态',
            width: 120,
          },
          getText: ({ row }) => selectOption.settlementForm[row.settlementStatus],
        },
      ],
      apiFn: accidentList,
    },
  }
  return {
    configData,
  }
}
